export default __webpack_public_path__ + "static/david-ea5ca5094440b62205ad460691397703.png";